/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDriverRequest
 */
export interface UpdateDriverRequest {
    /**
     * 営業所ID<br>グループがP3連携版に属さない場合は更新不可
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    salesOfficeId: string;
    /**
     * パスワード (英大文字・英小文字・数字・記号を組み合わせて20文字以内)<br>グループがP3連携版に属さない場合は更新不可
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    password?: string;
    /**
     * ドライバー姓 (姓名合計90文字以内)
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    driverLastName: string;
    /**
     * ドライバー名 (姓名合計90文字以内)
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    driverFirstName: string;
    /**
     * ドライバー姓-カナ (姓名合計90文字以内)
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    driverLastNameKana: string;
    /**
     * ドライバー名-カナ (姓名合計90文字以内)
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    driverFirstNameKana: string;
    /**
     * ドライバー姓-英字 (姓名合計90文字以内)
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    driverLastNameEn: string;
    /**
     * ドライバー名-英字 (姓名合計90文字以内)
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    driverFirstNameEn: string;
    /**
     * 性別 (1:男性, 2:女性, 3:指定なし)
     * @type {number}
     * @memberof UpdateDriverRequest
     */
    gender: number;
    /**
     * 免許証番号（12桁半角数字ハイフンなし）
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    licenseNumber: string;
    /**
     * 免許証有効期限（YYYY/MM/DD形式）
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    driverLicenseExpiration: string;
    /**
     * 配車可否<br>グループがP3連携版に属さない場合は更新不可
     * @type {boolean}
     * @memberof UpdateDriverRequest
     */
    available: boolean;
    /**
     * 配車アプリ連携リスト（1:Uber, 2:DiDi）
     * @type {Array<number>}
     * @memberof UpdateDriverRequest
     */
    dispatchApps: Array<number>;
    /**
     * 備考
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    description?: string;
}

/**
 * Check if a given object implements the UpdateDriverRequest interface.
 */
export function instanceOfUpdateDriverRequest(value: object): value is UpdateDriverRequest {
    if (!('salesOfficeId' in value) || value['salesOfficeId'] === undefined) return false;
    if (!('driverLastName' in value) || value['driverLastName'] === undefined) return false;
    if (!('driverFirstName' in value) || value['driverFirstName'] === undefined) return false;
    if (!('driverLastNameKana' in value) || value['driverLastNameKana'] === undefined) return false;
    if (!('driverFirstNameKana' in value) || value['driverFirstNameKana'] === undefined) return false;
    if (!('driverLastNameEn' in value) || value['driverLastNameEn'] === undefined) return false;
    if (!('driverFirstNameEn' in value) || value['driverFirstNameEn'] === undefined) return false;
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('licenseNumber' in value) || value['licenseNumber'] === undefined) return false;
    if (!('driverLicenseExpiration' in value) || value['driverLicenseExpiration'] === undefined) return false;
    if (!('available' in value) || value['available'] === undefined) return false;
    if (!('dispatchApps' in value) || value['dispatchApps'] === undefined) return false;
    return true;
}

export function UpdateDriverRequestFromJSON(json: any): UpdateDriverRequest {
    return UpdateDriverRequestFromJSONTyped(json, false);
}

export function UpdateDriverRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDriverRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'salesOfficeId': json['sales_office_id'],
        'password': json['password'] == null ? undefined : json['password'],
        'driverLastName': json['driver_last_name'],
        'driverFirstName': json['driver_first_name'],
        'driverLastNameKana': json['driver_last_name_kana'],
        'driverFirstNameKana': json['driver_first_name_kana'],
        'driverLastNameEn': json['driver_last_name_en'],
        'driverFirstNameEn': json['driver_first_name_en'],
        'gender': json['gender'],
        'licenseNumber': json['license_number'],
        'driverLicenseExpiration': json['driver_license_expiration'],
        'available': json['available'],
        'dispatchApps': json['dispatch_apps'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function UpdateDriverRequestToJSON(json: any): UpdateDriverRequest {
    return UpdateDriverRequestToJSONTyped(json, false);
}

export function UpdateDriverRequestToJSONTyped(value?: UpdateDriverRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sales_office_id': value['salesOfficeId'],
        'password': value['password'],
        'driver_last_name': value['driverLastName'],
        'driver_first_name': value['driverFirstName'],
        'driver_last_name_kana': value['driverLastNameKana'],
        'driver_first_name_kana': value['driverFirstNameKana'],
        'driver_last_name_en': value['driverLastNameEn'],
        'driver_first_name_en': value['driverFirstNameEn'],
        'gender': value['gender'],
        'license_number': value['licenseNumber'],
        'driver_license_expiration': value['driverLicenseExpiration'],
        'available': value['available'],
        'dispatch_apps': value['dispatchApps'],
        'description': value['description'],
    };
}

